<script setup lang="ts">
import { GetEntitiesFromVersion } from '@/lib/entityInfo';
import { CreateSimulationParty } from '@/lib/trashsim/loaders/party';
import { LoadPrefill } from '@/lib/trashsim/loaders/prefill';
import type { PartyKey } from '@/lib/trashsim/party';
import type { Settings } from '@/lib/trashsim/settings';
import type { Wave, Waves } from '@/lib/trashsim/waves';
import { ref, toRaw } from 'vue';
import { useRoute } from 'vue-router';
import { useKeypress } from 'vue3-keypress';

const props = defineProps<{
    modelValue: Wave
    waves: Waves
    settings: Settings
}>()

const route = useRoute()
const debug = ref(false)
const result = ref("")
useKeypress({
    keyEvent: "keydown",
    keyBinds: [
        {
            keyCode: 68,
            modifiers: ["ctrlKey", "altKey"],
            success: () => { debug.value = !debug.value },
            preventDefault: true
        }
    ]
})


// dumpers
const dumpEntities = () => {
    let entities = GetEntitiesFromVersion(props.settings.version)
    let data = {attackers: {}, defenders: {}}
    
    let party: PartyKey
    for (party in props.modelValue.parties) {
        data[party] = CreateSimulationParty(toRaw(props.modelValue.parties[party]), entities, props.settings)
    }
    result.value = JSON.stringify(data, undefined, 2)
}

const dumpParties = () => {
    result.value = JSON.stringify(props.modelValue, undefined, 2)
}

const dumpSettings = () => {
    result.value = JSON.stringify(props.settings)
}

const dumpDebugPack = () => {
    btoa(JSON.stringify({waves: props.waves, settings: props.settings}))
}

const loadDebugPack = () => {
    console.error("You probably should have implemented this")
}

const dumpPrefill = () => {
    try {
        result.value = JSON.stringify(LoadPrefill(route.hash))
    }
    catch(err) {
        console.error(err)
    }
}
</script>

<template>
    <section id="debug" v-show="debug">
        <div>
            <button @click="dumpEntities">Dump entities</button>
            <button @click="dumpParties">Dump waves</button>
            <button @click="dumpSettings">Dump Settings</button>
            <button @click="dumpDebugPack">Dump debug pack</button>
            <button @click="loadDebugPack">Load debug pack</button>
            <button @click="dumpPrefill">Dump Prefill</button>
        </div>
        <textarea>{{ result }}</textarea>
    </section>
</template>

<style scoped>
#debug {
    position: absolute;
    top: 0;
    left: 0;
    width: 90vw;
    height: 85vh;
    max-height: 90vh;
    margin: 10vh 5vw 5vh 5vw;
    background-color: aquamarine;
    z-index: 9999;
    background: rgba(30, 43, 57, 0.9);
}

#debug div {
    height: 5%;
    max-height: 5%;
}

#debug textarea {
    display: block;
    color: white;
    font-family: 'Courier New', Courier, monospace;
    margin: 0;
    padding: 0;
    border: 0;
    height: 95%;
    max-height: 95%;
    width: 100%;
    max-width: 100%;
    background: none;
}

/* #debug pre span {
    color: red;
} */
</style>